import { CtaBand } from "@/components/CtaBand";
import { PageHero } from "@/components/PageHero";
import { Seo } from "@/components/Seo";
import { useReveals } from "@/lib/motion";

const PRINCIPLES = [
  {
    title: "Show the working",
    body: "A cost per tonne is only useful if you can explain it. Formulas are published with worked examples, units are always labelled, and presets are marked as presets.",
  },
  {
    title: "One model, not ten spreadsheets",
    body: "Site data, design assumptions, fleet, plant and overheads belong in the same place, so a change in one is visible in the others.",
  },
  {
    title: "Say what is not finished",
    body: "The documentation states which parts are complete and which are still simplified. We would rather you know before you rely on a number.",
  },
];

export default function About() {
  const scope = useReveals();

  return (
    <div ref={scope}>
      <Seo
        title="About"
        description="MineOptics builds cost modelling software for the people who write open-pit studies: the engineers who have to defend the number."
        path="/about"
      />
      <PageHero
        eyebrow="About"
        title="For the engineers who have to defend the number."
        lede="MineOptics is cost modelling software for the people who write open-pit studies. It takes a site from drillhole data to a scenario a team can read, question and change, then issue as a numbered report."
      />

      <section data-theme="light" className="bg-bg">
        <div className="shell py-24 md:py-36">
          <p data-fade className="eyebrow text-mute">
            How we build
          </p>
          <ol className="mt-8">
            {PRINCIPLES.map((principle, index) => (
              <li key={principle.title}>
                <span data-rule className="rule" />
                <div data-fade className="grid gap-4 py-9 md:grid-cols-[5rem_minmax(0,1fr)_minmax(0,1.2fr)] md:gap-8 md:py-14">
                  <span className="eyebrow pt-2 text-mute">{String(index + 1).padStart(2, "0")}</span>
                  <h2 className="subtitle uppercase">{principle.title}</h2>
                  <p className="lede max-w-[54ch] text-mute">{principle.body}</p>
                </div>
              </li>
            ))}
          </ol>
          <span data-rule className="rule" />
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
